import * as React from "react";
import { useParams } from "react-router-dom";
import { Button } from "@src/ui/views/button";
import { baseQuery } from "@src/integrations/redux/base-query";

export function DebugScreen() {
  const { spaceId } = useParams<{ spaceId: string }>();
  const [cookieString, setCookieString] = React.useState(document.cookie);
  const [authMe, setAuthMe] = React.useState<any>(null);
  const [welfareDefs, setWelfareDefs] = React.useState<any>(null);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    // read cookies
    setCookieString(document.cookie);

    // sample authenticated “me” call
    fetch(`${import.meta.env.VITE_API_BASE}/api/v1/auth/me`, {
      method: "GET",
      credentials: "include",
    })
      .then((r) => {
        if (!r.ok) throw new Error(`auth/me → ${r.status}`);
        return r.json();
      })
      .then(
        
            (d) => { setCookieString(document.cookie);setAuthMe(d)}
            )
      .catch((e) => setError(e.toString()));

    // sample welfare definitions fetch
    if (spaceId) {
      fetch(`${import.meta.env.VITE_API_BASE}/api/v1/${spaceId}/welfare/definitions`, {
        credentials: "include",
      })
        .then((r) => {
          if (!r.ok) throw new Error(`welfare defs → ${r.status}`);
          return r.json();
        })
        .then((d) => setWelfareDefs(d))
        .catch((e) => setError(e.toString()));
    }
  }, [spaceId]);

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-bold">🔧 Debug Console</h1>

      {error && (
        <div className="p-4 bg-red-100 text-red-700 rounded">
          <strong>Error:</strong> {error}
        </div>
      )}

      <section>
        <h2 className="font-semibold">Cookies</h2>
        <pre className="bg-gray-100 p-2 rounded">{cookieString}</pre>
      </section>

      <section>
        <h2 className="font-semibold">GET /auth/me</h2>
        <pre className="bg-gray-100 p-2 rounded">{JSON.stringify(authMe, null, 2)}</pre>
      </section>

      <section>
        <h2 className="font-semibold">GET /welfare/definitions</h2>
        <pre className="bg-gray-100 p-2 rounded">{JSON.stringify(welfareDefs, null, 2)}</pre>
      </section>

      <Button
        onClick={() => {
          // force re-fetch
          setError(null);
          setAuthMe(null);
          setWelfareDefs(null);
          setCookieString(document.cookie);
        }}
      >
        Refresh Debug Info
      </Button>
    </div>
  );
}
